import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-career-journey',
  templateUrl: './career-journey.component.html',
  styleUrls: ['./career-journey.component.scss']
})
export class CareerJourneyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
